export interface PublicPendingBookingState {
  appointmentId: string;
  patientId: string | null;
  pendingExpiry: string | null;
}

export const getPublicPendingBookingStorageKey = (
  facilityId: string,
  staffId: string,
  slotId: string,
  phoneNumber: string,
) => `public_pending_booking:${facilityId}:${staffId}:${slotId}:${phoneNumber}`;

export function loadPublicPendingBooking(
  storageKey: string,
): PublicPendingBookingState | null {
  if (!storageKey) return null;

  try {
    const rawValue = sessionStorage.getItem(storageKey);
    if (!rawValue) return null;
    return JSON.parse(rawValue) as PublicPendingBookingState;
  } catch {
    return null;
  }
}

export function savePublicPendingBooking(
  storageKey: string,
  state: PublicPendingBookingState,
) {
  if (!storageKey) return;

  try {
    sessionStorage.setItem(storageKey, JSON.stringify(state));
  } catch {
    // Ignore session storage failures in public flow.
  }
}

export function clearPublicPendingBooking(storageKey: string) {
  if (!storageKey) return;

  try {
    sessionStorage.removeItem(storageKey);
  } catch {
    // Ignore session storage failures in public flow.
  }
}
